
export const GET_COMPANIES = "GET_COMPANIES"
export const GET_COMPANIES_SUCCESS = "GET_COMPANIES_SUCCESS"
export const GET_COMPANIES_FAIL = "GET_COMPANIES_FAIL"

export const UPDATE_COMPANY = "UPDATE_COMPANY"
export const UPDATE_COMPANY_SUCCESS = "UPDATE_COMPANY_SUCCESS"
export const UPDATE_COMPANY_FAIL = "UPDATE_COMPANY_FAIL"

export const DELETE_COMPANY = "DELETE_COMPANY"
export const DELETE_COMPANY_SUCCESS = "DELETE_COMPANY_SUCCESS"
export const DELETE_COMPANY_FAIL = "DELETE_COMPANY_FAIL"

export const TOGGLE_COMPANY_STATUS = "TOGGLE_COMPANY_STATUS"
export const TOGGLE_COMPANY_STATUS_SUCCESS = "TOGGLE_COMPANY_STATUS_SUCCESS"
export const TOGGLE_COMPANY_STATUS_FAIL = "TOGGLE_COMPANY_STATUS_FAIL"

export const ADD_NEW_COMPANY = "ADD_NEW_COMPANY"
export const ADD_NEW_COMPANY_SUCCESS = "ADD_NEW_COMPANY_SUCCESS"
export const ADD_NEW_COMPANY_FAIL = "ADD_NEW_COMPANY_FAIL"

export const GET_COMPANY_DETAIL = "GET_COMPANY_DETAIL"
export const GET_COMPANY_DETAIL_SUCCESS = "GET_COMPANY_DETAIL_SUCCESS"
export const GET_COMPANY_DETAIL_FAIL = "GET_COMPANY_DETAIL_FAIL"

export const ASSIGN_PLAN = "ASSIGN_PLAN"
export const ASSIGN_PLAN_SUCCESS = "ASSIGN_PLAN_SUCCESS"
export const ASSIGN_PLAN_FAIL = "ASSIGN_PLAN_FAIL"
